
import BaseButton from "@/components/base/BaseButton.vue";
import BaseDateInput from "@/components/base/BaseDateInput.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import useAccountBookings from "@/composables/useAccountBookings";
import useVuelidate from "@vuelidate/core";
import { defineComponent, reactive } from "vue";
import { fromLocaleDate } from "@/helpers/dateHelper";

export default defineComponent({
	components: { BaseInput, BaseDateInput, BaseButton },
	setup() {
		const { fetchBookings, loading } = useAccountBookings();

		const state = reactive({
			bookingNumber: "",
			customerEmail: "",
			date: "",
			customerName: "",
		});

		const rules = {
			bookingNumber: {},
			customerEmail: {},
			date: {},
			customerName: {},
		};

		const v$ = useVuelidate(rules, state);

		const submitForm = () => {
			fetchBookings({
				...(state.date ? { endDate: fromLocaleDate(state.date) } : {}),
				...(state.bookingNumber ? { bookingNumber: +state.bookingNumber } : {}),
				...(state.customerName ? { name: state.customerName } : {}),
				...(state.customerEmail ? { email: state.customerEmail } : {}),
				status: 1,
				includeCancelled: false,
			});
		};
		return {
			v$,
			submitForm,
			loading,
		};
	},
});
